import type { NavIconName } from './nav-icon';

// Notification kind → icon tile for the merchant notification centre (design
// notifVals() M:8355-8390: icon tile by kind pay / kyc / svc / limit / promote / live).
// Kinds are open strings on the wire (notifications.kind), so this matches by family
// prefix and falls back to a neutral bell — an unknown kind still renders (AP-D10).
export type NotificationTone = 'info' | 'warn' | 'ok' | 'neutral';

const FAMILIES: readonly { test: RegExp; icon: NavIconName; tone: NotificationTone }[] = [
  // A business decided in Approvals (DR-19): business_approved / business_rejected.
  { test: /^business_rejected/, icon: 'store', tone: 'warn' },
  { test: /^business/, icon: 'store', tone: 'ok' },
  { test: /^payment_kyc/, icon: 'shield', tone: 'info' },
  { test: /^(proof|payment)/, icon: 'wallet', tone: 'info' },
  { test: /^(kyc|payment_application|nid)/, icon: 'shield', tone: 'info' },
  { test: /^(service|catalog)/, icon: 'layers', tone: 'warn' },
  { test: /^(plan|subscription|limit|cap)/, icon: 'alert', tone: 'warn' },
  { test: /^offer/, icon: 'tag', tone: 'ok' },
  { test: /^review/, icon: 'star', tone: 'ok' },
  { test: /^booking/, icon: 'calendar', tone: 'ok' },
];

export function notificationKind(kind: string): { icon: NavIconName; tone: NotificationTone } {
  const hit = FAMILIES.find((f) => f.test.test(kind));
  return hit ? { icon: hit.icon, tone: hit.tone } : { icon: 'bell', tone: 'neutral' };
}
